module.exports = __webpack_public_path__ + "static/N2N8s-9377f284e02c571678279b535eb0a130.jpg";